import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-forbidden",
  "use": "icon-forbidden-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-forbidden\"><path d=\"M512 953.6a441.6 441.6 0 1 1 0-883.2 441.6 441.6 0 0 1 0 883.2z m0-64a377.6 377.6 0 1 0 0-755.2 377.6 377.6 0 0 0 0 755.2z\" p-id=\"5438\" /><path d=\"M182.1696 227.4304l45.2608-45.2608 614.4 614.4-45.2608 45.2608z\" p-id=\"5439\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol